<template>
<div class="topic-box" ref="topic">
  <Item v-for="item of list" :key="item.id" v-bind="item"/>
</div>
</template>
<script>
import Item from './topicLIstItem'
import { get } from '../../../utils/request'
export default {
  components: {
    Item
  },
  data () {
    return {
      list: [],
      loading: false,
      page: 1,
      size: 10,
      count: 0
    }
  },
  mounted () {
    this.getAllTopic()
    this.addUpRefresh()
  },
  methods: {
    addUpRefresh () {
      const el = this.$refs.topic
      if (!el) {
        return
      }
      const offsetHeight = el.offsetHeight
      el.addEventListener('scroll', () => {
        if (this.loading) {
          return
        }
        const scrollHeight = el.scrollHeight
        const scrollTop = el.scrollTop
        if (offsetHeight + scrollTop >= scrollHeight) {
          const { count, list, page } = this
          if (count > list.length) {
            this.page = page + 1
            el.scrollTop = el.scrollTop - 60
            this.getAllTopic()
          }
        }
      })
    },
    getAllTopic () {
      this.loading = true
      const promise = get({
        url: `/topic/h5topic?page=${this.page}&size=${this.size}`
      })
      promise.then(res => {
        const { data: { code, detail: { count, list } } } = res
        if (Object.is(code, 200)) {
          this.list = [...this.list, ...list]
          this.count = count
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.topic-box {
  height: 100vh;
  margin-bottom: 21px;
  overflow-y: scroll;
  /deep/ .topic-item:last-child {
    margin-bottom: 48px;
  }
}
</style>
